<script setup>
import { ref } from 'vue'
import UserSelector from '@/components/UserSelector/index.vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  item: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:show', 'confirm'])

const selectedUserId = ref(null)
const loading = ref(false)

const handleConfirm = () => {
  if (!selectedUserId.value) return
  loading.value = true
  emit('confirm', {
    demandId: props.item?.id,
    handlerId: selectedUserId.value
  })
}

const handleClose = () => {
  selectedUserId.value = null
  loading.value = false
  emit('update:show', false)
}

// 父组件调用，分配完成后关闭
const done = () => {
  loading.value = false
  handleClose()
}

defineExpose({ done })
</script>

<template>
  <Teleport to="body">
    <Transition name="modal">
      <div
        v-if="show"
        class="fixed inset-0 z-50 flex items-center justify-center p-4"
      >
        <div class="absolute inset-0 bg-black/50" @click="handleClose"></div>
        <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4">
          <div class="px-6 py-4 border-b border-slate-200">
            <h3 class="text-lg font-semibold text-slate-900">分配需求</h3>
            <p class="text-sm text-slate-500 mt-1">选择一个处理人来负责此需求</p>
          </div>
          <div class="p-6">
            <!-- 需求摘要 -->
            <div v-if="item" class="mb-4 p-3 bg-slate-50 rounded-lg">
              <p class="text-sm text-slate-600 line-clamp-2">{{ item.description }}</p>
              <p class="text-xs text-slate-400 mt-1">提交人：{{ item.contactName }}</p>
            </div>

            <!-- 用户选择器 -->
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-2">选择处理人</label>
              <UserSelector
                v-model="selectedUserId"
                placeholder="请选择处理人"
              />
            </div>
          </div>
          <div class="px-6 py-4 border-t border-slate-200 flex justify-end gap-3">
            <button
              @click="handleClose"
              class="px-5 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
            >
              取消
            </button>
            <button
              @click="handleConfirm"
              :disabled="!selectedUserId || loading"
              class="px-5 py-2.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer"
            >
              {{ loading ? '分配中...' : '确认分配' }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}

.modal-enter-active .relative,
.modal-leave-active .relative {
  transition: transform 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .relative,
.modal-leave-to .relative {
  transform: scale(0.95);
}
</style>
